import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import Axios from '../../config/axios';
import { toast, confirm } from '@rickylandino/react-messages';
import { useNavigate, useLocation } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { Select, Empty, Spin, Alert, Table, Divider, List, Tag, message } from 'antd';
import Globals from '../../config/globals';
import DatePicker from 'react-datepicker';
import { TbUserCheck } from 'react-icons/tb';
import { GiJumpAcross } from 'react-icons/gi';
import SendEmailSlider from '../Email/SendEmailSlider';

export default function SearchJSS(props) {
    const userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));

    const { register, getValues, setValue, control, watch } = useForm();

    const [state, setState] = useState({
        shows: [],
        qccerts: [],
        //prospectsources: [],
        servicecategories: [],
        salesreps: [],
        states: [],
        customers: [],
        dataLoaded: false,
        showsLoaded: false,
        searchRunning: false,
        showSearchRunning: false,
        hasSearchBeenRunYet: false,
        currentPage: 1,
        currentPageSize: 10,
        customerShows: [],
        showSendEmailSlider: false,
        selectedContact: {},
        selectedCustomer: {},
        emailInformation: {}
    });

    const [loadingDropdowns, setLoadingDropdowns] = useState(true);
    const [showEmailSlider, setShowEmailSlider] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    const [selectedRowKeys, setSelectedRowKeys] = useState(['']);

    useEffect(() => {
        setLoadingDropdowns(true);

        LoadSearchFilters();

        var mySearchRunning;
        if (location.state.selectedCustomerId) {
            mySearchRunning = true;
        }
        else {
            mySearchRunning = false;
        }

        setState({
            ...state,
            searchRunning: mySearchRunning
        });

    }, [props]);

    useEffect(() => {
        let myPage = 1;
        let mySizePerPage = 10;
        if (props.page !== undefined) { myPage = props.page; }
        if (props.sizePerPage !== undefined) { mySizePerPage = props.sizePerPage; }
        if (props.selectedCustomerId !== undefined) {
            setValue('selectedCustomerId', props.selectedCustomerId);

            //this highlights the previously selected row in the table 
            let selRows = [props.selectedCustomerId];
            setSelectedRowKeys([...selRows]);
        }

        if (loadingDropdowns === false) {
            //console.log(state.currentPage);

            if (props.fromTopNav === true) {
                ResetSearchCriteria();
            }
            else {
                setState({
                    ...state,
                    searchRunning: true
                });

                SetSearchCriteria(myPage, mySizePerPage); // This is be executed when `loadingDropdowns` state changes
            }
        }
    }, [loadingDropdowns])

    function LoadSearchFilters() {
        let postdata = {};
        postdata.jobshopdivision = userInfo.jobShopDivision

        Axios.post(`/api/GetJSSSearchFilters`, postdata
        ).then(response => {
            let shows = response.data.shows;
            let qccerts = response.data.qccerts;
            //let prospectsources = response.data.prospectsources;
            let states = response.data.states;
            let servicecategories = response.data.servicecategories;
            let salesreps = response.data.salesreps;

            setState({
                ...state,
                shows,
                qccerts,
                salesreps,
                servicecategories,
                states
            });

            setLoadingDropdowns(false);

        }).catch(error => {
            console.log(error);
        });
    }

    function handleJumpTo(e, record, index) {
        navigate("/customerview", { state: { selectedCustomerId: record.id, callingComponent: 'SearchJSS', page: state.currentPage, sizePerPage: state.currentPageSize } });
    }

    const columns = [
        {
            dataIndex: 'contact_id',
            title: 'Contact ID',
            key: 'contact_id',
            hidden: true
        }, {
            dataIndex: 'id',
            title: 'ID',
            key: 'id',
            width: 100
        }, {
            dataIndex: 'exhibitor',
            title: 'Type',
            key: 'exhibitor',
            width: 130,
            align: 'center',
            sorter: (a, b) => a.exhibitor - b.exhibitor,
            render: (exhibitor) => {
                return (
                    <div>
                        {exhibitor ? <Tag className="table-row-exhibitor">Exhibitor</Tag> : <Tag className="table-row-prospect">Prospect</Tag>}
                    </div>
                );
            }
        }, {
            dataIndex: 'name',
            title: 'Company',
            key: 'name',
            sorter: (a, b) => a.company.localeCompare(b.company)
        }, {
            dataIndex: 'jsS_sales_rep',
            title: 'Sales Rep',
            key: 'jsS_sales_rep',
            sorter: (a, b) => a.name.localeCompare(b.name)
        }, {
            dataIndex: 'jss_name',
            title: 'Contact',
            key: 'jss_name',
            sorter: (a, b) => a.name.localeCompare(b.name)
        }, {
            dataIndex: 'phone',
            title: 'Phone',
            key: 'phone',
            sorter: (a, b) => a.phone.localeCompare(b.phone)
        //}, {
        //    dataIndex: 'email',
        //    title: 'Email',
        //    key: 'email',
        //    width: 100,
        //    sorter: (a, b) => a.email.localeCompare(b.email)
        }, {
            dataIndex: 'email',
            title: 'Email',
            key: 'email',
            sorter: (a, b) => a.email.localeCompare(b.email),
            render: (text, record, index) => (
                <button type="button" class="btn btn-link btn-lg" onClick={(e) => EmailContact(e, record, index, state.currentPage, state.currentPageSize)}>{record.email}</button>
            ),
        }, {
            title: 'Jump To',
            key: 'action',
            width: 120,
            render: (text, record, index) => 
                <div id="jumpTo" className="hover"><TbUserCheck id="jumpTo" className="fa-1x text-icon" onClick={(e) => handleJumpTo(e, record, index)} /></div>
            ,
            align: 'center'
        }
    ].filter(item => !item.hidden);

    const onSelectChange = (newSelectedRowKeys) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        columnWidth: 0, // Set the width to 0
        renderCell: () => "", // Render nothing inside
    };

    function SetSearchCriteria(myPage, mySizePerPage) {
        setState({
            ...state,
            searchRunning: true,
            dataLoaded: false
        });

        let lastSearchCriteria = JSON.parse(window.sessionStorage.getItem("lastSearchCriteria"));

        if (lastSearchCriteria === null) {
            ResetSearchCriteria();
            return;
        }

        setValue('formFields.searchTarget', lastSearchCriteria.searchtarget);
        setValue('formFields.searchType', lastSearchCriteria.searchtype);
        setValue('formFields.custid', lastSearchCriteria.custid);
        setValue('formFields.company', lastSearchCriteria.company);
        setValue('formFields.contact', lastSearchCriteria.contact);
        setValue('formFields.phone', lastSearchCriteria.phone);
        setValue('formFields.fax', lastSearchCriteria.fax);
        setValue('formFields.city', lastSearchCriteria.city);
        setValue('formFields.email', lastSearchCriteria.email);
        
        //sales status
        if (lastSearchCriteria.salesstatuses !== '') {
            setValue('formFields.salesstatuses', lastSearchCriteria.salesstatuses.split(","));
        }
        else {
            setValue('formFields.salesstatuses', []);
        }

        //shows
        if (lastSearchCriteria.shows !== '') {
            setValue('formFields.shows', lastSearchCriteria.shows.split(",").map(Number));
        }
        else {
            setValue('formFields.shows', []);
        }

        //states
        if (lastSearchCriteria.states !== '') {
            setValue('formFields.states', lastSearchCriteria.states.split(","));
        }
        else {
            setValue('formFields.states', []);
        }

        //source
        setValue('formFields.prospectsource', lastSearchCriteria.prospectsources);
        //if (lastSearchCriteria.prospectsources !== '') {
        //    setValue('formFields.prospectsources', lastSearchCriteria.prospectsources.split(","));
        //}
        //else {
        //    setValue('formFields.prospectsources', []);
        //}

        //service categories
        if (lastSearchCriteria.servicecategories !== '') {
            setValue('formFields.servicecategories', lastSearchCriteria.servicecategories.split(","));
        }
        else {
            setValue('formFields.servicecategories', []);
        }

        //qccerts
        if (lastSearchCriteria.qccerts !== '') {
            setValue('formFields.qccerts', lastSearchCriteria.qccerts.split(","));
        }
        else {
            setValue('formFields.qccerts', []);
        }

        //sales status
        if (lastSearchCriteria.salesreps !== '') {
            setValue('formFields.salesreps', lastSearchCriteria.salesreps.split(","));
        }
        else {
            setValue('formFields.salesreps', []);
        }

        //featured package
        if (lastSearchCriteria.featuredpackage !== '') {
            setValue('formFields.featuredpackage', lastSearchCriteria.shows.split(",").map(Number));
        }
        else {
            setValue('formFields.featuredpackage', lastSearchCriteria.featuredpackage);
        }

        setState({
            ...state
        });

        if (lastSearchCriteria.searchtarget !== 'Both' || lastSearchCriteria.searchtype !== 'StartsWith' || lastSearchCriteria.custid !== '' || lastSearchCriteria.company !== '' || lastSearchCriteria.contact !== '' ||
            lastSearchCriteria.phone !== '' || lastSearchCriteria.fax !== '' || lastSearchCriteria.city !== '' || lastSearchCriteria.email !== '' || lastSearchCriteria.salesstatuses !== '' ||
            lastSearchCriteria.shows !== '' || lastSearchCriteria.states !== '' || lastSearchCriteria.prospectsource !== '' || lastSearchCriteria.qccerts !== '' || lastSearchCriteria.salesreps !== '' || lastSearchCriteria.featuredpackage !== '')
        {
            toast.info("Your last search criteria filters were re-loaded");

            handleSearchClick(myPage, mySizePerPage, location.state.selectedCustomerId);
        }
    }

    function ResetSearchCriteria() {
        setValue('formFields.searchTarget', 'Both');
        setValue('formFields.searchType', 'StartsWith');
        setValue('formFields.custid', '');
        setValue('formFields.company', '');
        setValue('formFields.contact', '');
        setValue('formFields.phone', '');
        setValue('formFields.fax', '');
        setValue('formFields.city', '');
        setValue('formFields.email', '');
        setValue('formFields.shows', []);
        setValue('formFields.salesstatuses', []);
        setValue('formFields.servicecategories', []);
        setValue('formFields.qccerts', []);
        //setValue('formFields.prospectsources', []);
        setValue('formFields.prospectsource', '');
        setValue('formFields.states', []);
        setValue('selectedCustomerId', null);
        setValue('formFields.salesreps', []);
        setValue('formFields.featuredpackage', '');

        setState({
            ...state,
            customers: [],
            hasSearchBeenRunYet: false,
            showsLoaded: false,
            currentPage: 1,
            currentPageSize: 10
        });

        window.sessionStorage.removeItem("lastSearchCriteria");
    }

    function handleSearchClick(myPage, mySizePerPage, selectedCustomerId) {
        if (getValues().formFields.searchTarget === 'Both' && getValues().formFields.searchType === 'StartsWith' && getValues().formFields.custid === '' && getValues().formFields.company === '' && getValues().formFields.domain === '' && getValues().formFields.contact === '' &&
            getValues().formFields.phone === '' && getValues().formFields.fax === '' && getValues().formFields.city === '' && getValues().formFields.email === '' && String(getValues().formFields.salesstatuses) === "" &&
            String(getValues().formFields.shows) === "" && String(getValues().formFields.states) === "" && String(getValues().formFields.servicecategories) === "" && String(getValues().formFields.prospectsource) === "" && String(getValues().formFields.qccerts) === "" && String(getValues().formFields.salesreps) === "") {
            toast.error("You must select at least one field to search on");

            return;
        }

        setState({
            ...state,
            searchRunning: true,
            dataLoaded: false,
            customerShows: [],
            customers: []
        });

        let postdata = {
            searchtarget: getValues().formFields.searchTarget,
            searchtype: getValues().formFields.searchType,
            custid: getValues().formFields.custid,
            company: getValues().formFields.company,
            contact: getValues().formFields.contact,
            phone: getValues().formFields.phone,
            fax: getValues().formFields.fax,
            city: getValues().formFields.city,
            states: String(getValues().formFields.states),
            email: getValues().formFields.email.replace('@', '@@'),
            //prospectsources: String(getValues().formFields.prospectsources),
            prospectsources: getValues().formFields.prospectsource,
            fax: getValues().formFields.fax,
            servicecategories: String(getValues().formFields.servicecategories),
            salesstatuses: String(getValues().formFields.salesstatuses),
            shows: String(getValues().formFields.shows),
            qccerts: String(getValues().formFields.qccerts),
            domain: getValues().formFields.domain,
            salesreps: String(getValues().formFields.salesreps),
            featuredpackage: String(getValues().formFields.featuredpackage)
        };
        window.sessionStorage.setItem("lastSearchCriteria", JSON.stringify(postdata));

        Axios.post(`/api/GetJSSCompaniesByDetailedSearchValues`, postdata
        ).then(response => {
            let customers = response.data;

            if (customers.length > 0) {
                let arr = [];
                if (selectedCustomerId === null) {
                    arr.push(customers[0].id);
                }
                else {
                    arr.push(selectedCustomerId);
                }
                setSelectedRowKeys(arr);

                if (selectedCustomerId) {
                    getCustomerShows(selectedCustomerId, customers, myPage, mySizePerPage);
                }
                else {
                    getCustomerShows(customers[0].id, customers, myPage, mySizePerPage);
                }
            }
            else {
                setState({
                    ...state,
                    showsLoaded: false,
                    showSearchRunning: false,
                    customers: []
                });
            }
        }).catch(error => {
            console.log(error);
        });
    }

    function handleExportSearchResults() {
        let postdata = {
            searchtarget: getValues().formFields.searchTarget,
            searchtype: getValues().formFields.searchType,
            custid: getValues().formFields.custid,
            company: getValues().formFields.company,
            contact: getValues().formFields.contact,
            phone: getValues().formFields.phone,
            fax: getValues().formFields.fax,
            city: getValues().formFields.city,
            states: String(getValues().formFields.states),
            email: getValues().formFields.email.replace('@', '@@'),
            //prospectsources: String(getValues().formFields.prospectsources),
            prospectsources: getValues().formFields.prospectsource,
            fax: getValues().formFields.fax,
            servicecategories: String(getValues().formFields.servicecategories),
            salesstatuses: String(getValues().formFields.salesstatuses),
            shows: String(getValues().formFields.shows),
            qccerts: String(getValues().formFields.qccerts),
            domain: getValues().formFields.domain,
            salesreps: String(getValues().formFields.salesreps),
            featuredpackage: getValues().formFields.featuredpackage
        };

        const key = "downloadleads";
        message.loading({
            content: 'Downloading Your Search Results...',
            key,
            duration: 0,
            //style: {
            //    position: "fixed",
            //    bottom: 0,
            //    left: 0
            //},
        });

        Axios.post(`/api/DownloadJSSSearchResults`, postdata, {
            responseType: 'blob'
        }).then(response => {
            console.log(response.data);

            message.destroy(key);

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = "JSSSearchResults.xlsx";
            a.click();
            window.URL.revokeObjectURL(url);
        }).catch(error => {
            console.log(error);
        });

    }

    function handleShowsChange(value) {
        setValue('formFields.shows', value);
        setState({ ...state });
    }

    function handleSalesStatusesChange(value) {
        setValue('formFields.salesstatuses', value);
        setState({ ...state });
    }

    function handleQCCertsChange(value) {
        setValue('formFields.qccerts', value);
        setState({ ...state });
    }

    function handleSalesRepChange(value) {
        setValue('formFields.salesreps', value);
        setState({ ...state });
    }

    function handleFeaturedPackageChange(value) {
        setValue('formFields.featuredpackage', value);
        setState({ ...state });
    }

    //function handleProspectSourcesChange(value) {
    //    setValue('formFields.prospectsources', value);
    //    setState({ ...state });
    //}

    function handleServiceCategoryChange(value) {
        setValue('formFields.servicecategories', value);
        setState({ ...state });
    }

    function handleStatesChange(value) {
        setValue('formFields.states', value);
        setState({ ...state });
    }

    const { Option } = Select;

    function updatePageState(page, pageSize) {
        setState({
            ...state,
            currentPage: page,
            currentPageSize: pageSize
        });
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleSearchClick(state.currentPage, state.currentPageSize, null);
        }
    };

    const showcolumns = [
        {
            dataIndex: 'showcode',
            title: 'Show Code',
            key: 'showcode'
        }, {
            dataIndex: 'name',
            title: 'Name',
            key: 'name'
        }, {
            dataIndex: 'salesstatus',
            title: 'Sales Status',
            key: 'salesstatus'
        }
    ].filter(item => !item.hidden);

    function getCustomerShows(id, customers, myPage, mySizePerPage) {
        setState({
            ...state,
            showsLoaded: false,
            showSearchRunning: true
        });

        let postdata = {};
        postdata.company_id = id;
        Axios.post(`/api/GetCustomerShows`, postdata
        ).then(response => {
            const shows = response.data;

            setState({
                ...state,
                customers,
                hasSearchBeenRunYet: true,
                dataLoaded: true,
                searchRunning: false,
                customerShows: shows,
                showsLoaded: true,
                showSearchRunning: false,
                currentPage: myPage,
                currentPageSize: mySizePerPage
            });
        }).catch(error => {
            console.log(error);
        });
    }

    function EmailContact(e, record, index, myPage, mySizePerPage) {
        //this gets the contact and associated customer objects although this is not the most efficient way
        Axios.get(`/api/GetContactAndCustomerToEmail`, {
            params: {
                id: record.id,
                contact_id: record.contact_id
            }
        }).then(response => {
            let contact = response.data.contact;
            let customer = response.data.customer

            var emailInformation = {
                id: '',
                sendTo: contact.email,
                selectedCustomer: customer,
                selectedContact: contact,
                selectedCustomerId: customer.id,
                selectedContactId: contact.contact_id,
                userId: userInfo.userId,
                fileList: [],
                emailContent: '',
            }

            setState({
                ...state,
                selectedContact: contact,
                selectedCustomer: customer,
                emailInformation,
                currentPage: myPage,
                currentPageSize: mySizePerPage
            });

            setShowEmailSlider(true);

        }).catch(error => {
            console.log(error);
        });

        //this gets the contact and associated customer objects although this is not the most efficient way
        //Axios.get(`/api/GetContactInfoByContactId`, {
        //    params: {
        //        id: record.contact_id
        //    }
        //}).then(response => {
        //    let contact = response.data;

        //    console.log(contact);

        //    let postdata = {
        //        company_id: record.id,
        //        jobshopdivision: userInfo.jobShopDivision
        //    };

        //    Axios.post(`/api/GetCustomerById`, postdata
        //    ).then(response => {
        //        //Init Customer fields 
        //        let customer = response.data.customer;

        //        console.log(customer);

        //        var emailInformation = {
        //            id: '',
        //            sendTo: contact.email,
        //            selectedCustomer: customer,
        //            selectedContact: contact,
        //            selectedCustomerId: customer.id,
        //            selectedContactId: contact.contact_id,
        //            userId: userInfo.userId,
        //            fileList: [],
        //            emailContent: '',
        //        }

        //        console.log(emailInformation);

        //        setState({
        //            ...state,
        //            selectedContact: contact,
        //            selectedCustomer: customer,
        //            emailInformation,
        //            currentPage: myPage,
        //            currentPageSize: mySizePerPage
        //        });

        //        setShowEmailSlider(true);

        //    }).catch(error => {
        //        console.log(error);
        //    });
        //}).catch(error => {
        //    console.log(error);
        //});
    }

    return (
        <>
            <div className="row" onKeyDown={handleKeyDown} >
                <div className="form-group col-lg-3 col-12">
                    <h3 className="frame-heading">
                        D2P Shows Customer Search
                    </h3>
                </div>
                <div className="form-group col-lg-3 col-12">
                    <div className="rcorners p-2">
                        <label className="form-label">Search For:</label>&nbsp;&nbsp;
                        <input type="radio" name="searchTarget" {...register("formFields.searchTarget")} value="Customers" className="mt-1" />&nbsp;<label className="form-label">Exhibitors</label>&nbsp;&nbsp;&nbsp;
                        <input type="radio" name="searchTarget" {...register("formFields.searchTarget")}value="Prospects" className="mt-1" />&nbsp;<label className="form-label">Prospects</label>&nbsp;&nbsp;&nbsp;
                        <input type="radio" name="searchTarget" {...register("formFields.searchTarget")}value="Both" className="mt-1" />&nbsp;<label className="form-label">Both</label>
                    </div>
                </div>
                <div className="form-group col-lg-1 col-12"></div>
                <div className="form-group col-lg-3 col-12">
                    <div className="rcorners p-2">
                        <label className="form-label">Search Type:</label>&nbsp;&nbsp;
                        <input type="radio" name="searchType" {...register("formFields.searchType")} value="StartsWith" className="mt-1" />&nbsp;<label className="form-label">Starts With</label>&nbsp;&nbsp;&nbsp;
                        <input type="radio" name="searchType" {...register("formFields.searchType")} value="Includes" className="mt-1" />&nbsp;<label className="form-label">Includes</label>&nbsp;&nbsp;&nbsp;
                    </div>
                </div>
                <div className="form-group col-lg-2 col-12"></div>

                <div className="form-group col-lg-1 col-12">
                    <label className="form-label">Cust ID</label>
                    <input type="text" {...register("formFields.custid")} className="form-control-custom" />
                </div>

                <div className="form-group col-lg-2 col-12">
                    <label className="form-label">Company</label>
                    <input type="text" {...register("formFields.company")} className="form-control-custom" />
                </div>

                <div className="form-group col-lg-2 col-12">
                    <label className="form-label">Web Site</label>
                    <input type="text" {...register("formFields.domain")} className="form-control-custom" />
                </div>

                <div className="form-group col-lg-2 col-12">
                    <label className="form-label">Contact</label>
                    <input type="text" {...register("formFields.contact")} className="form-control-custom" />
                </div>

                <div className="form-group col-lg-1 col-12">
                    <label className="form-label">Phone</label>
                    <input type="text" {...register("formFields.phone")} className="form-control-custom" />
                </div>
                <div className="form-group col-lg-1 col-12">
                    <label className="form-label">Fax</label>
                    <input type="text" {...register("formFields.fax")} className="form-control-custom" />
                </div>
                <div className="form-group col-lg-2 col-12">
                    <label className="form-label">City</label>
                    <input type="text" {...register("formFields.city")} className="form-control-custom" />
                </div>
                <div className="form-group col-lg-1 col-12">
                    <label className="form-label">State</label>
                    <Select id="ddProspectStates"
                        value={getValues().formFields?.states}
                        className="form-control-custom"
                        mode="multiple"
                        placeholder="Select one or more States"
                        onChange={handleStatesChange}
                        className="form-control-custom w-100"
                        bordered={false}
                    >
                        {state.states.map((s) => <Option key={s.fullName} value={s.state}>{s.state}</Option>)}
                    </Select>
                </div>

                <div className="form-group col-lg-3 col-12">
                    <label className="form-label">Email</label>
                    <input type="text" {...register("formFields.email")} className="form-control-custom" />
                </div>
                <div className="form-group col-lg-2 col-12">
                    <label className="form-label">Prospect Source</label>
                    <input type="text" {...register("formFields.prospectsource")} className="form-control-custom" />
                    {/*<Select id="ddProspectSources"*/}
                    {/*    value={getValues().formFields?.prospectsources}*/}
                    {/*    className="form-control-custom"*/}
                    {/*    mode="multiple"*/}
                    {/*    placeholder="Select one or more Sources"*/}
                    {/*    onChange={handleProspectSourcesChange}*/}
                    {/*    className="form-control-custom w-100"*/}
                    {/*    bordered={false}*/}
                    {/*>*/}
                    {/*    {state.prospectsources.map((src) => <Option key={src.source} value={src.source}>{src.source}</Option>)}*/}
                    {/*</Select>*/}
                </div>
                <div className="form-group col-lg-1 col-12">
                    <label className="form-label">Sales Status</label>
                    <Select id="ddStatus"
                        value={getValues().formFields?.salesstatuses}
                        className="form-control-custom"
                        mode="multiple"
                        placeholder="Select one or more Status"
                        onChange={handleSalesStatusesChange}
                        className="form-control-custom w-100"
                        bordered={false}
                    >
                        <Option value='Cancel'>Cancel</Option>
                        <Option value='Closed'>Closed</Option>
                        <Option value='Closing'>Closing</Option>
                        <Option value='No'>No</Option>
                        <Option value='Prospect'>Prospect</Option>
                        <Option value='Qualified'>Qualified</Option>
                        <Option value='Renewal'>Renewal</Option>
                        <Option value='Suspect'>Suspect</Option>
                        <Option value='Till'>Till</Option>
                        <Option value='Yes'>Yes</Option>
                    </Select>
                </div>
                <div className="form-group col-lg-2 col-12">
                    <label className="form-label">Show</label>
                    <Select id="ddSShows"
                        value={getValues().formFields?.shows}
                        className="form-control-custom"
                        mode="multiple"
                        placeholder="Select one or more Shows"
                        onChange={handleShowsChange}
                        className="form-control-custom w-100"
                        bordered={false}
                    >
                        {state.shows.map((show) => <Option key={show.showcode} value={show.showcode}>{show.name}</Option>)}
                    </Select>
                </div>
                <div className="form-group col-lg-2 col-12">
                    <label className="form-label">Service Category</label>
                    <Select id="ddServiceCategories"
                        value={getValues().formFields?.servicecategories}
                        className="form-control-custom"
                        mode="multiple"
                        placeholder="Select one or more service category"
                        onChange={handleServiceCategoryChange}
                        className="form-control-custom w-100"
                        bordered={false}
                    >
                        {state.servicecategories.map((scat) => <Option key={scat.category} value={scat.category}>{scat.categoryName}</Option>)}
                    </Select>
                </div>
                <div className="form-group col-lg-2 col-12">
                    <label className="form-label">QC Certs</label>
                    <Select id="ddQCCerts"
                        value={getValues().formFields?.qccerts}
                        className="form-control-custom"
                        mode="multiple"
                        placeholder="Select one or more QC Certs"
                        onChange={handleQCCertsChange}
                        className="form-control-custom w-100"
                        bordered={false}
                    >
                        {state.qccerts.map((cert) => <Option key={cert.qcname} value={cert.qcname}>{cert.qcname}</Option>)}
                    </Select>
                </div>

                <div className="form-group col-lg-2 col-12">
                    <label className="form-label">Sales Rep</label>
                    <Select id="ddSalesReps"
                        value={getValues().formFields?.salesreps}
                        className="form-control-custom"
                        mode="multiple"
                        placeholder="Select one or more sales reps"
                        onChange={handleSalesRepChange}
                        className="form-control-custom w-100"
                        bordered={false}
                    >
                        {state.salesreps.map((rep) => <Option key={rep.name} value={rep.name}>{rep.name}</Option>)}
                    </Select>
                </div>
                <div className="form-group col-lg-1 col-12">
                    <label className="form-label">FEP</label>
                    <Select
                        id="ddFeaturedPackage"
                        value={getValues().formFields?.featuredpackage}
                        className="form-control-custom w-100"
                        mode="single"
                        placeholder="Select one or more"
                        onChange={handleFeaturedPackageChange}
                        bordered={false}
                    >
                        <Option value=""></Option>
                        <Option value="NULL">Blank</Option>
                        <Option value="Yes">Yes</Option>
                        <Option value="No">No</Option>
                    </Select>
                </div>

                <div className="row">
                    <div className="form-group col-lg-8 col-8 d-flex align-items-center">
                        <Button className="btn btn-submit"
                            onClick={() => handleSearchClick(state.currentPage, state.currentPageSize, null)}>
                            Search
                        </Button>

                        <button className="btn btn-outline-primary ms-3" onClick={ResetSearchCriteria}>
                            Reset Selections
                        </button>

                        {state.customers.length > 0 && (
                            <button className="btn btn-success ms-auto" onClick={handleExportSearchResults}>
                                Export Search Results
                            </button>
                        )}
                    </div>
                    <div className="form-group col-lg-4 col-4"></div>
                </div>

                <div className="form-group col-lg-9 col-9">
                    <hr />
                    <Spin spinning={state.searchRunning}>
                        <div style={state.searchRunning ? {} : { display: 'none' }}>
                            <Alert
                                message="Loading Companies..."
                                description="Please stand by while we retrieve companies that match your selected criteria"
                                type="info"
                            />
                        </div>
                        {!state.searchRunning &&
                            <div className="row">
                                {state.customers.length === 0 ?
                                    <div style={state.dataLoaded === true ? {} : { display: 'none' }}>
                                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={
                                            <span>
                                                {state.hasSearchBeenRunYet === false ? "Search for Exhibitors and Exhibitor Prospects using the search criteria above" : "No companies found matching your search criteria"}
                                            </span>
                                        } />
                                    </div>
                                    :
                                    <Table
                                        //rowClassName={(record, index) => record.exhibitor ? 'table-row-exhibitor' : 'table-row-prospect'}
                                        className="custom-ant-selection"
                                        rowKey={item => item.id}
                                        rowSelection={rowSelection}
                                        hideSelectionColumn={true}
                                        bordered
                                        dataSource={state.customers}
                                        columns={columns}
                                        pagination={{
                                            defaultPageSize: 10,
                                            showSizeChanger: true,
                                            pageSizeOptions: ['10', '25', '50', '100'],
                                            showTotal: (total, range) => (
                                                <span className="color-dark-blue" style={{ left: 0, position: "absolute", fontSize: "large", fontWeight: "bold" }}>
                                                    Showing {range[0]}-{range[1]} of {total}
                                                </span>
                                            ),
                                            onChange: (page, pageSize) => {
                                                updatePageState(page, pageSize);
                                            },
                                            current: state.currentPage,
                                            pageSize: state.currentPageSize
                                        }}
                                        onRow={(record, index) => {
                                            return {
                                                onKeyDown: (e) => {

                                                    //e.preventDefault();
                                                    //console.log(e.key);
                                                    //try {
                                                    //    if (e.key === "ArrowUp" && index > 0)
                                                    //        e.target.previousSibling.focus();
                                                    //    if (e.key === "ArrowDown" && index < state.customers.length)
                                                    //        e.target.nextSibling.focus();
                                                    //} catch (err) {
                                                    //    // failure
                                                    //}
                                                },
                                                onClick: () => {
                                                    let selRows = [record.id];
                                                    setSelectedRowKeys([...selRows]);

                                                    getCustomerShows(record.id, state.customers, state.currentPage, state.currentPageSize);
                                                },
                                                onDoubleClick: (e) => {
                                                    handleJumpTo(e, record, index);
                                                }
                                            }
                                        }}
                                    />
                                }
                            </div>
                        }
                    </Spin>
                </div>
                <div className="form-group col-lg-3 col-3">
                    <hr />
                    <Spin spinning={state.showSearchRunning}>
                        <div style={state.showSearchRunning ? {} : { display: 'none' }}>
                            <Alert
                                message="Loading Shows..."
                                description="Please stand by while we retrieve shows for this customer"
                                type="info"
                            />
                        </div>
                        {!state.showSearchRunning && state.customers.length > 0 &&
                            <div className="row">
                                {state.customerShows.length === 0 ?
                                    <div style={state.showsLoaded === true ? {} : { display: 'none' }}>
                                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={
                                            <span>
                                                No shows found for selected customer
                                            </span>
                                        } />
                                    </div>
                                    :
                                    <div>
                                        {state.showsLoaded &&
                                            <>
                                                <Divider orientation="left">Selected Exhibitor Shows</Divider>
                                                <div
                                                    id="scrollableDiv"
                                                    style={{
                                                        height: 400,
                                                        overflow: 'auto',
                                                        padding: '0 16px',
                                                        border: '1px solid rgba(140, 140, 140, 0.35)',
                                                    }}
                                                >
                                                    <List
                                                      size='small'
                                                      header=''
                                                      footer=''
                                                      dataSource={state.customerShows}
                                                      renderItem={(item) => <List.Item>{item.name}: {item.salesstatus ? item.salesstatus : ''}</List.Item>}
                                                    />
                                                </div>
                                            </>
                                        }
                                    </div>
                                }
                            </div>
                        }
                    </Spin>
                </div>
            </div>

            {showEmailSlider &&
                <SendEmailSlider emailInformation={state.emailInformation} showPane={showEmailSlider} hidePane={() => setShowEmailSlider(false)} />
            }
        </>
    );
}